export function isEditorWindow(window) {
    return 'commonConfig' in window && window.commonConfig !== undefined;
}
